export Component from './components/Component';
export Container from './components/Container';

export * as actions from './actions';
export reducer from './reducer'


/** WEBPACK FOOTER **
 ** ./src/app/modules/base/index.js
 **/